import { render, staticRenderFns } from "./PlaceholderWrapper.vue?vue&type=template&id=4f831494"
import script from "./PlaceholderWrapper.vue?vue&type=script&lang=js"
export * from "./PlaceholderWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports